/*global $*/
/*eslint no-undef: "error"*/
export default class HeaderMobile {
    classButton = 'header-mobile--button'
    classBlock = 'header-mobile--block'

    classBlockOpen = 'header-mobile-open'

    constructor () {
        let self = this

        $(`.${self.classButton}`).click(function () {
            $(`.${self.classBlock}`).toggleClass(self.classBlockOpen)
        })
    }
}
